import * as React from "react";
import SEO from "../components/seo";
import Layout from "../components/layout";
import SimpleHero from "../components/v2/simple-hero";
import HeadlineBanner from "../components/v2/headline-banner";
import FiftyFiftyHorizontal from "../components/v2/fifty-fifty-horizontal";
import ImageGridBanner from "../components/v2/image-grid-banner";
import MediaSlider from "../components/v2/media-slider";
import GetUpdates from "../components/v2/get-updates";
import DetailsFooter from "../components/v2/details-footer";

// Hooks
import useTheArtPageImages from "../hooks/useTheArtPageImages";

const TheArt = () => {
  return (
    <Layout
      className="art"
      bodyTheme="light"
      isFooter={false}
      headerLayout="mobile"
    >
      <SEO title="The Art" />
      <SimpleHero
        contentData={
          {
            pre_title: "The",
            title: "Art",
          }
        }
        imageData={useTheArtPageImages({name: "the-art-1"})}
      />
      <HeadlineBanner
        className="spacing spacing--general"
        pre_title="The intersection of"
        title="ART & Outdoors"
      />
      <FiftyFiftyHorizontal
        mediaPosition="left"
        contentColumns={5}
        contentOffset={1}
        mediaColumns={6}
        mediaOffset={0}
        imageData={useTheArtPageImages({name: "the-art-2"})}
      >
        <p>At evo, we’ve always been fascinated by the intersection of art and the outdoors. This focus on art is core to who we are - and it’s an essential part of the Campus Salt Lake experience.</p>
      </FiftyFiftyHorizontal>
      <ImageGridBanner
        className="spacing spacing--spacing-3"
        imageData={useTheArtPageImages({name: "the-art-3"})}
      />
      <FiftyFiftyHorizontal
        contentColumns={5}
        contentOffset={1}
        mediaColumns={5}
        mediaOffset={1}
        imageData={useTheArtPageImages({name: "the-art-4"})}
      >
        <p>Visit our gallery space and check out inspiring work from local artists. You’ll also have the chance to discover art in numerous other locations throughout campus. In addition, each room in the evo Hotel will feature the work of a different Utah artist. All the art at Campus Salt Lake has been curated by Anna and Adam Clark.</p>
      </FiftyFiftyHorizontal>
      <HeadlineBanner
        className="spacing spacing--general"
        pre_title="About"
        title="Annastasia Clark"
      />
      <FiftyFiftyHorizontal
        imageData={useTheArtPageImages({name: "the-art-5"})}
      >
        <p>Annastasia Clark is a designer and artist from Salt Lake City, Utah. She graduated from the University of Utah with a B.F.A. in Printmaking and a B.S. in Environmental and Sustainability Studies. For the past decade she has worked as an environmental and graphic designer, as well as running her own printing press specializing in woodblock prints. Annastasia’s passion for nature and wildlife is the driving force behind her creative expression. Her art explores the connection between wildlife and the environment, focusing on the unseen intricacies and magic of the animal world, and the delicate balance of nature.</p>
        <p>Born and raised in SLC, UT Annastasia started taking art classes as soon as she could hold a paintbrush. Growing up and participating in the local art community has been a gift throughout life, and she was ecstatic to help bring over 50 artists together for such a unique project to Salt Lake City.</p>
      </FiftyFiftyHorizontal>
      <HeadlineBanner
        className="spacing spacing--general"
        pre_title="About"
        title="Adam Clark"
      />
      <FiftyFiftyHorizontal
        imageData={useTheArtPageImages({name: "the-art-9"})}
      >
        <p>Adam Clark is a Salt Lake City based adventure photographer who specializes in outdoor sports and lifestyle photography. Adam’s need for adventure has taken him around the world to work with friends, heroes, mentors, and beautiful landscapes. Adam’s photography has been featured in hundreds of magazines, and he’s worked for a wide range of commercial clients.</p>
      </FiftyFiftyHorizontal>
      <MediaSlider
        className="spacing spacing--general"
        slides={[
          {
            imageData: useTheArtPageImages({name: "the-art-6"}),
            description: "",
          },
        ]}
      />
      <GetUpdates className="spacing spacing--general" />
      <DetailsFooter
        imageData={useTheArtPageImages({name: "the-art-7"})}
        imageDataHover={useTheArtPageImages({name: "the-art-8"})}
        linkData={{
          title: "Read Story",
          project_url: "/the-vision/",
        }}
        pre_title="Up Next"
        title="The Vision"
      />
    </Layout>
  )
}

export default TheArt
